/*

MeganeTemplate

Version: 4.1.0
Website: http://megane-template.com/
License: Dentsu Isobar All Rights Reserved.

*/

export default class jAccordion {

    constructor(selector, option) {

        this.selector = selector;

        //option
        if(option == null) option = {};
        this.toggleSpeed = option.toggleSpeed ? option.toggleSpeed : 0;
        this.btnElm = option.btnElm ? option.btnElm : ".j-accordion_btn";
        this.detailElm = option.detailElm ? option.detailElm : ".j-accordion_detail";

        this.OpenEnd = function(){};
        this.CloseEnd = function(){};

        this.Init();

    }


    /**
    **
    ** Init
    **
    **/
    Init() {

        const that = this;

        $(this.selector).find(this.detailElm).not(".active").hide();

        $(this.selector).find(this.btnElm).on("click", function(e){

            e.preventDefault();

            that.target = this;
            that.Toggle();


        });

    }


    /**
    **
    ** Toggle
    **
    **/
    Toggle(elm) {

        var target = $(elm)[0] ? $(elm)[0] : this.target;

        if( $(target).hasClass('active') ){

            this.Close(elm);

        } else {

            this.Open(elm);

        }

    }


    /**
    **
    ** Open, Close
    **
    **/
    Open(elm) {

        var target = $(elm)[0] ? $(elm)[0] : this.target;
        var index = $(this.selector).find(this.btnElm).index(target);

        var that = this;

        $(this.selector).find(this.btnElm).eq(index).addClass("active");

        $(this.selector).find(this.detailElm).eq(index).slideDown(this.toggleSpeed ,function(){

            that.OpenEnd(index);

        }).addClass("active");

    }

    Close(elm) {

        var target = $(elm)[0] ? $(elm)[0] : this.target;
        var index = $(this.selector).find(this.btnElm).index(target);

        var that = this;

        $(this.selector).find(this.btnElm).eq(index).removeClass("active");

        $(this.selector).find(this.detailElm).eq(index).slideUp(this.toggleSpeed ,function(){

            that.CloseEnd(index);

        }).removeClass("active");

    }

    CloseIgnoreThis(elm) {

        var target = $(elm)[0] ? $(elm)[0] : this.target;
        var index = $(this.selector).find(this.btnElm).index(target);

        var ignore = ":not(:eq("+ index +"))";
        var that = this;

        $(this.selector).find(this.btnElm + ignore).removeClass("active");

        $(this.selector).find(this.detailElm + ignore).slideUp(this.toggleSpeed ,function(){

            that.CloseEnd();

        }).removeClass("active");

    }

}
